import _taggedTemplateLiteral from "/home/badil/Projects/Giodicart/volantino-interattivo-giodicart/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  height: ", "px;\n  width: ", "px;\n  border-radius: ", "px;\n  background-color: #DBDBDB;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  height: ", "px;\n  width: ", "px;\n  border-radius: ", "px;\n  background-color: #8F1D30;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  top: ", ";\n  bottom: ", ";\n  right: ", ";\n  left: ", ";\n  z-index: 10;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from "styled-components";
import posed from "react-pose";
import { serverResponse } from "../../../src/util/fakeServer";
export var Floating = styled(posed.div({
  pressable: true,
  hover: {
    scale: 1.1
  },
  press: {
    x: 0,
    delay: 100
  },
  open: {
    x: function x(props) {
      return props.number > 3 && (props.right ? -props.distance : props.distance);
    },
    y: function y(props) {
      return props.number > 6 && (props.top ? props.distance : -props.distance);
    }
  },
  closed: {
    x: 0,
    y: 0,
    rotate: 0
  }
}))(_templateObject(), function (props) {
  return props.top ? "50" : "null";
}, function (props) {
  return props.top ? "50px" : "none";
}, function (props) {
  return !props.top && !serverResponse.config.adsense || !window.location.pathname.includes("leaflet") && !window.location.pathname.includes("pages") ? "10px" : serverResponse.config.adsense ? "100px" : "none";
}, function (props) {
  return props.right ? "50px" : "none";
}, function (props) {
  return !props.right ? "10px" : "none";
});
export var Container = styled(posed.div({
  hoverable: true,
  pressable: true,
  init: {
    scale: 1
  },
  hover: {
    scale: 1.2
  },
  press: {
    scale: 0.8
  }
}))(_templateObject2(), function (props) {
  return props.size;
}, function (props) {
  return props.size;
}, function (props) {
  return props.size;
});
export var Item = styled(posed.div({
  hoverable: true,
  pressable: true,
  init: {
    scale: 1
  },
  hover: {
    scale: 1.2
  },
  press: {
    scale: 0.8
  },
  enter: {
    y: function y(props) {
      return Math.sin(props.i) * props.distance;
    },
    x: function x(props) {
      return Math.cos(props.i) * props.distance;
    },
    opacity: 1,
    delay: 150,
    transition: {
      y: {
        type: "spring",
        stiffness: 500,
        damping: 10
      },
      x: {
        type: "spring",
        stiffness: 500,
        damping: 10
      },
      boxShadow: {
        delay: 300,
        type: "spring",
        stiffness: 500,
        damping: 10
      },
      default: {
        duration: 150
      }
    }
  },
  exit: {
    y: 0,
    x: 0,
    opacity: 0,
    transition: {
      duration: 150
    }
  }
}))(_templateObject3(), function (props) {
  return props.size;
}, function (props) {
  return props.size;
}, function (props) {
  return props.size;
});